import React, {Component} from 'react';
import moment from 'moment';

export default class NewsItem extends Component {

    render() {
        const data = this.props.data;
        const date = moment(data.pubDate).format('YYYY-MM-DD');
        return (
            <a href={data.link} target="_blank" className="news-row">
                <h3 className="news-title">{data.title}</h3>
                <span className="published">{date}</span>
                <p className="news-teaser">{data.description}</p>
                <span className="icon"></span>
            </a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NewsItem.js